// Curated list of well-known wine appellations used by the iframe live-demo
// search bar. Kept on the client (no backend roundtrip for autocomplete) —
// EtOH itself accepts free-form appellation strings, so this list is purely
// a UX nicety to help users discover what works.
//
// If/when EtOH exposes a "/appellations" endpoint, replace this with a fetch.
export const APPELLATIONS = [
  // Bordeaux & Sud-Ouest
  "Bordeaux", "Médoc", "Pauillac", "Margaux", "Saint-Estèphe", "Saint-Julien",
  "Pessac-Léognan", "Graves", "Sauternes", "Barsac",
  "Saint-Émilion", "Pomerol", "Fronsac", "Côtes de Bourg", "Cadillac",
  "Cahors", "Madiran", "Jurançon", "Irouléguy", "Buzet", "Bergerac", "Monbazillac",
  // Bourgogne
  "Chablis", "Mâcon", "Pouilly-Fuissé", "Saint-Véran",
  "Côte de Nuits", "Gevrey-Chambertin", "Vosne-Romanée", "Nuits-Saint-Georges",
  "Chambolle-Musigny", "Morey-Saint-Denis",
  "Côte de Beaune", "Meursault", "Puligny-Montrachet", "Chassagne-Montrachet",
  "Pommard", "Volnay", "Beaune", "Aloxe-Corton",
  // Beaujolais
  "Beaujolais", "Brouilly", "Fleurie", "Morgon", "Moulin-à-Vent", "Chiroubles",
  "Juliénas", "Saint-Amour", "Côte de Brouilly", "Régnié", "Chénas",
  // Rhône
  "Côte-Rôtie", "Condrieu", "Saint-Joseph", "Hermitage", "Crozes-Hermitage",
  "Cornas", "Saint-Péray",
  "Châteauneuf-du-Pape", "Gigondas", "Vacqueyras", "Lirac", "Tavel",
  "Côtes du Rhône", "Côtes du Rhône Villages",
  // Loire
  "Sancerre", "Pouilly-Fumé", "Menetou-Salon", "Quincy", "Reuilly",
  "Touraine", "Vouvray", "Chinon", "Bourgueil", "Saumur", "Saumur-Champigny",
  "Anjou", "Savennières", "Coteaux du Layon", "Bonnezeaux", "Muscadet",
  // Champagne & Alsace
  "Champagne", "Crémant d'Alsace", "Crémant de Loire", "Crémant de Bourgogne",
  "Alsace", "Alsace Grand Cru", "Riesling d'Alsace", "Gewurztraminer",
  // Languedoc-Roussillon
  "Languedoc", "Corbières", "Minervois", "Picpoul de Pinet", "Saint-Chinian",
  "Faugères", "Pic Saint-Loup", "Limoux", "Blanquette de Limoux",
  "Côtes du Roussillon", "Maury", "Banyuls", "Rivesaltes", "Collioure",
  "Montpeyroux",
  // Provence & Corse
  "Côtes de Provence", "Bandol", "Cassis", "Bellet", "Coteaux d'Aix-en-Provence",
  "Patrimonio", "Ajaccio", "Vin de Corse",
  // Jura & Savoie
  "Arbois", "Château-Chalon", "Côtes du Jura", "L'Étoile",
  "Vin de Savoie", "Roussette de Savoie", "Crépy", "Seyssel",
  // Italie
  "Barolo", "Barbaresco", "Chianti", "Chianti Classico", "Brunello di Montalcino",
  "Vino Nobile di Montepulciano", "Amarone della Valpolicella", "Soave",
  "Prosecco", "Franciacorta", "Etna", "Taurasi",
  // Espagne
  "Rioja", "Ribera del Duero", "Priorat", "Rías Baixas", "Jerez", "Cava",
  "Toro", "Bierzo", "Rueda",
  // Portugal
  "Douro", "Porto", "Vinho Verde", "Dão", "Alentejo", "Bairrada", "Madeira",
];
